/* src/app/pages/credit-cards/credit-card-summary/credit-card-summary.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
:host {
  display: flex;
  flex-direction: column;
  background: var(--cds-background-accent);
  padding: 32px 24px;
}
:host ::ng-deep {
}
:host ::ng-deep .default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
:host ::ng-deep .default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
:host ::ng-deep .default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
:host ::ng-deep .default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
:host ::ng-deep .default-flex-column {
  display: flex;
  flex-flow: column;
}
:host ::ng-deep .default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
:host ::ng-deep .rounded-circle {
  border-radius: 50%;
}
:host ::ng-deep pcp-header-multiple-accounts-relationship section {
  background: var(--cds-card-background);
  box-shadow: 0px 1px 2px 0px color-mix(in srgb, var(--cds-foreground-600) 30%, transparent), 0px 2px 6px 2px color-mix(in srgb, var(--cds-foreground-600) 15%, transparent);
}
:host ::ng-deep pcp-header-multiple-accounts-relationship h5 {
  color: var(--cds-text-strong) !important;
  font-weight: 700;
}
:host ::ng-deep pcp-header-multiple-accounts-relationship th.cdk-header-cell,
:host ::ng-deep pcp-header-multiple-accounts-relationship td.cdk-cell {
  padding: 0;
}
:host ::ng-deep pcp-header-multiple-accounts-relationship th.cdk-header-cell {
  color: var(--cds-text-strong);
  font-weight: 400;
}
:host ::ng-deep pcp-header-multiple-accounts-relationship .cdk-cell {
  color: var(--cds-text-strong);
  font-weight: 700;
}
:host ::ng-deep pcp-header-multiple-accounts-relationship .cdk-table {
  gap: 4px;
}
:host ::ng-deep pcp-header-multiple-accounts-relationship .cdk-row {
  margin-top: 0;
}
:host ::ng-deep pcp-header-multiple-accounts-relationship .cdk-header-row,
:host ::ng-deep pcp-header-multiple-accounts-relationship .cdk-row {
  grid-template-columns: 190px 130px auto;
  gap: 24px;
}
:host ::ng-deep pcp-header-multiple-accounts-relationship .cdk-column-product_tier {
  display: flex;
  align-items: center;
  gap: 8px;
}
:host ::ng-deep pcp-header-multiple-accounts-relationship .cdk-column-product_tier i {
  color: var(--cds-primary-600);
  cursor: pointer;
  flex-shrink: 0;
}
:host ::ng-deep .default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
:host ::ng-deep .default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
:host ::ng-deep .default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
:host ::ng-deep .default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
:host ::ng-deep .default-flex-column {
  display: flex;
  flex-flow: column;
}
:host ::ng-deep .default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
:host ::ng-deep .rounded-circle {
  border-radius: 50%;
}
:host ::ng-deep pcp-invoice-list-carousel main {
  height: 160px;
  box-shadow: none;
  border-radius: 0;
}
:host ::ng-deep pcp-invoice-list-carousel main aside {
  visibility: visible !important;
  pointer-events: auto !important;
}
:host ::ng-deep pcp-invoice-list-carousel main .left {
  padding: 0 24px 0 24px !important;
}
:host ::ng-deep pcp-invoice-list-carousel main .right {
  padding: 0 24px 0 24px !important;
}
:host ::ng-deep pcp-invoice-list-carousel section {
  gap: 24px !important;
}
:host ::ng-deep pcp-invoice-list-carousel section > div:not(.carousel-item-placeholder) {
  outline: none !important;
  align-self: stretch !important;
  width: 151px !important;
  min-width: 151px !important;
}
:host ::ng-deep pcp-invoice-list-carousel section > div:not(.carousel-item-placeholder):not(:has(.invoice-selected-card)) {
  display: flex !important;
  flex-direction: column !important;
  align-items: stretch !important;
  gap: 12px !important;
  border: 1px solid transparent !important;
  border-radius: 2px !important;
  padding: 16px !important;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3), 0px 1px 2px rgba(0, 0, 0, 0.15) !important;
}
:host ::ng-deep pcp-invoice-list-carousel section > div:not(.carousel-item-placeholder):not(:has(.invoice-selected-card)) > div {
  display: contents !important;
}
:host ::ng-deep pcp-invoice-list-carousel section > div:not(.carousel-item-placeholder):not(:has(.invoice-selected-card)) > div > h6 {
  order: 1;
  margin: 0 !important;
  height: 32px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  color: var(--cds-text-strong) !important;
  line-height: 1.5 !important;
  text-align: center !important;
  white-space: nowrap !important;
}
:host ::ng-deep pcp-invoice-list-carousel section > div:not(.carousel-item-placeholder):not(:has(.invoice-selected-card)) > div > pcp-invoice-status {
  order: 3;
  display: block !important;
  width: 100% !important;
}
:host ::ng-deep pcp-invoice-list-carousel section > div:not(.carousel-item-placeholder):not(:has(.invoice-selected-card)) > div > pcp-invoice-status h6 {
  width: 100% !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.5 !important;
  white-space: nowrap !important;
  text-transform: lowercase !important;
  background-color: transparent !important;
  border-radius: 0 !important;
  padding: 0 !important;
  text-align: center !important;
  margin: 0 !important;
}
:host ::ng-deep pcp-invoice-list-carousel section > div:not(.carousel-item-placeholder):not(:has(.invoice-selected-card)) > div > pcp-invoice-status h6::first-letter {
  text-transform: uppercase !important;
}
:host ::ng-deep pcp-invoice-list-carousel section > div:not(.carousel-item-placeholder):not(:has(.invoice-selected-card)) > div > pcp-invoice-status.c-info-500 h6 {
  color: var(--cds-primary-500) !important;
}
:host ::ng-deep pcp-invoice-list-carousel section > div:not(.carousel-item-placeholder):not(:has(.invoice-selected-card)) > div > pcp-invoice-status.c-warn-500 h6 {
  color: var(--cds-warn-500) !important;
}
:host ::ng-deep pcp-invoice-list-carousel section > div:not(.carousel-item-placeholder):not(:has(.invoice-selected-card)) > div > pcp-invoice-status.c-danger-500 h6 {
  color: var(--cds-danger-500) !important;
}
:host ::ng-deep pcp-invoice-list-carousel section > div:not(.carousel-item-placeholder):not(:has(.invoice-selected-card)) > div > pcp-invoice-status.c-foreground-400 h6 {
  color: var(--cds-foreground-400) !important;
}
:host ::ng-deep pcp-invoice-list-carousel section > div:not(.carousel-item-placeholder):not(:has(.invoice-selected-card)) > div > pcp-invoice-status.c-success h6 {
  color: var(--cds-success) !important;
}
:host ::ng-deep pcp-invoice-list-carousel section > div:not(.carousel-item-placeholder):not(:has(.invoice-selected-card)) > p {
  order: 2;
  margin: 0 !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  color: var(--cds-text-strong) !important;
  line-height: 1.5 !important;
  text-align: center !important;
  white-space: nowrap !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
  padding-top: 12px !important;
}
:host ::ng-deep pcp-invoice-list-carousel section > div:has(.invoice-selected-card) {
  border: none !important;
  padding: 0 !important;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3), 0px 1px 2px rgba(0, 0, 0, 0.15) !important;
  border-radius: 2px !important;
  background: transparent !important;
}
:host ::ng-deep .invoice-selected-card {
  display: flex !important;
  flex-direction: column !important;
  align-items: stretch !important;
  gap: 12px !important;
  padding: 16px !important;
  border: 1px solid var(--cds-primary-500) !important;
  border-radius: 2px !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
  width: 100% !important;
  height: 100% !important;
}
:host ::ng-deep .invoice-label {
  margin: 0 !important;
  height: 32px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  color: var(--cds-text-strong) !important;
  line-height: 1.5 !important;
  text-align: center !important;
  white-space: nowrap !important;
}
:host ::ng-deep .invoice-amount {
  margin: 0 !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  color: var(--cds-text-strong) !important;
  line-height: 1.5 !important;
  text-align: center !important;
  white-space: nowrap !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
  padding-top: 12px !important;
}
:host ::ng-deep .invoice-status-text {
  margin: 0 !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.5 !important;
  text-align: center !important;
  white-space: nowrap !important;
}
:host ::ng-deep .invoice-status-text.c-info-500 {
  color: var(--cds-primary-500) !important;
}
:host ::ng-deep .invoice-status-text.c-foreground-400 {
  color: var(--cds-foreground-400) !important;
}
:host ::ng-deep .invoice-status-text.c-danger-500 {
  color: var(--cds-danger-500) !important;
}
:host ::ng-deep .invoice-status-text.c-success {
  color: var(--cds-success) !important;
}
:host ::ng-deep .invoice-status-text.c-warn-500 {
  color: var(--cds-warn-500) !important;
}
:host ::ng-deep .default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
:host ::ng-deep .default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
:host ::ng-deep .default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
:host ::ng-deep .default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
:host ::ng-deep .default-flex-column {
  display: flex;
  flex-flow: column;
}
:host ::ng-deep .default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
:host ::ng-deep .rounded-circle {
  border-radius: 50%;
}
:host ::ng-deep h1,
:host ::ng-deep h2,
:host ::ng-deep h3,
:host ::ng-deep h4,
:host ::ng-deep h5,
:host ::ng-deep h6,
:host ::ng-deep label,
:host ::ng-deep p,
:host ::ng-deep b,
:host ::ng-deep small,
:host ::ng-deep span,
:host ::ng-deep strong {
  margin: 0px;
  -webkit-font-smoothing: antialiased;
}
:host ::ng-deep h1.cds-required::after,
:host ::ng-deep h2.cds-required::after,
:host ::ng-deep h3.cds-required::after,
:host ::ng-deep h4.cds-required::after,
:host ::ng-deep h5.cds-required::after,
:host ::ng-deep h6.cds-required::after,
:host ::ng-deep label.cds-required::after,
:host ::ng-deep p.cds-required::after,
:host ::ng-deep b.cds-required::after,
:host ::ng-deep small.cds-required::after,
:host ::ng-deep span.cds-required::after,
:host ::ng-deep strong.cds-required::after {
  font-family: var(--cds-font-family);
  font-size: inherit;
  font-weight: inherit;
  color: var(--cds-danger-500);
  line-height: inherit;
  content: "*";
}
:host ::ng-deep h1[class^=c-],
:host ::ng-deep h2[class^=c-],
:host ::ng-deep h3[class^=c-],
:host ::ng-deep h4[class^=c-],
:host ::ng-deep h5[class^=c-],
:host ::ng-deep h6[class^=c-],
:host ::ng-deep label[class^=c-],
:host ::ng-deep p[class^=c-],
:host ::ng-deep b[class^=c-],
:host ::ng-deep small[class^=c-],
:host ::ng-deep span[class^=c-],
:host ::ng-deep strong[class^=c-] {
  color: var(--color);
}
:host ::ng-deep b,
:host ::ng-deep strong,
:host ::ng-deep span {
  font-family: var(--cds-font-family);
}
:host ::ng-deep h1 {
  font-family: var(--cds-font-family);
  font-size: 30px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep h2 {
  font-family: var(--cds-font-family);
  font-size: 24px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep h3 {
  font-family: var(--cds-font-family);
  font-size: 22px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep h4 {
  font-family: var(--cds-font-family);
  font-size: 20px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep h5 {
  font-family: var(--cds-font-family);
  font-size: 18px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep h6 {
  font-family: var(--cds-font-family);
  font-size: 16px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep p {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-medium);
  line-height: 1;
}
:host ::ng-deep p.bold {
  font-weight: bold;
}
:host ::ng-deep label {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep small {
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep pcp-invoice-summary header h2 {
  font-family: var(--cds-font-family);
  font-size: 20px;
  font-weight: 600;
  color: var(--cds-text-secondary);
  line-height: 1;
}
:host ::ng-deep pcp-invoice-summary section {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 24px;
  margin-top: 24px;
}
:host ::ng-deep pcp-invoice-summary section .invoice-info label {
  font-size: 14px !important;
  color: var(--cds-text-strong) !important;
  font-weight: normal !important;
}
:host ::ng-deep pcp-invoice-summary section h4 {
  font-family: var(--cds-font-family);
  font-size: 16px;
  font-weight: 700;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep pcp-invoice-summary pcp-invoice-status h6 {
  border-radius: 4px !important;
  padding: 2px 8px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.5 !important;
  font-family: var(--cds-font-family) !important;
  text-transform: lowercase !important;
  text-align: left !important;
  margin: 0 !important;
  width: fit-content !important;
}
:host ::ng-deep pcp-invoice-summary pcp-invoice-status h6::first-letter {
  text-transform: uppercase !important;
}
:host ::ng-deep pcp-invoice-summary pcp-invoice-status.c-info-500 h6 {
  color: var(--cds-info-500) !important;
}
:host ::ng-deep pcp-invoice-summary pcp-invoice-status.c-warn-500 h6 {
  color: var(--cds-warn-500) !important;
}
:host ::ng-deep pcp-invoice-summary pcp-invoice-status.c-danger-500 h6 {
  color: var(--cds-danger-500) !important;
}
:host ::ng-deep pcp-invoice-summary pcp-invoice-status.c-foreground-400 h6 {
  color: var(--cds-foreground-400) !important;
}
:host ::ng-deep pcp-invoice-summary pcp-invoice-status.c-success h6 {
  color: var(--cds-success) !important;
}
main {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.credit-card-summary-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.summary-section {
  padding: 24px;
}
.summary-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}
.section-subtitle {
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: 400;
  color: --cds-text-strong;
  line-height: 1;
}
.invoices-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.invoices-title {
  font-family: var(--cds-font-family);
  font-size: 24px;
  font-weight: 700;
  color: var(--cds-text-primary);
  margin: 0;
}
.carousel-loading {
  display: flex;
  flex-direction: row;
  gap: 24px;
  overflow: hidden;
}
.categories-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.categories-title {
  font-family: var(--cds-font-family);
  font-size: 18px;
  font-weight: 700;
  color: --cds-text-strong;
  line-height: 1;
  margin: 0;
  font-feature-settings: "ss01" 1;
}
.categories-legend {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-template-rows: repeat(var(--legend-rows, 1), auto);
  grid-auto-flow: column;
  column-gap: 36px;
  row-gap: 12px;
}
.categories-legend__item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  min-width: 0;
}
.categories-legend__slider {
  width: 4px;
  height: 18px;
  border-radius: 8px;
  flex-shrink: 0;
}
.categories-legend__name {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: 600;
  color: --cds-text-strong;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  white-space: nowrap;
}
.categories-legend__info {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid var(--cds-text-light);
  background: transparent;
  color: var(--cds-text-light);
  font-size: 10px;
  font-style: italic;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}
.categories-legend__info:focus-visible {
  outline: 2px solid var(--cds-info-500);
  outline-offset: 2px;
}
.categories-legend__dots {
  flex: 1;
  height: 0;
  border-top: 1px dashed var(--cds-foreground-30, #d0e0e3);
}
.categories-legend__values {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: 400;
  color: --cds-text-strong;
  line-height: 1;
  white-space: nowrap;
  text-align: right;
  font-feature-settings: "ss01" 1;
}
/*# sourceMappingURL=credit-card-summary.component.css.map */
